// extracted by mini-css-extract-plugin
module.exports = {"fileSelector":"_1jEXA","btnUpload":"_3tk5k","fileName":"gVtzC","fileControl":"_1eANP"};